
export interface ICancelAdmission {
    id: number;
    appointmentNo?: string,
    encryptedId: string;
    name?: string;
    value: string;
    optionalId?: number;
    optionalText?: string;
    optionalText1?: string;
    optionalText2?: string;
    optionalText3?: string;
    optionalText4?: string;
    optionalData?: number;
    cost?: number;
    isSelected?: boolean;
    color: string;
    date: Date;
    time: object;
    status?: boolean;
    duration: number;
    optionalId1: number;
    exists: boolean;
    disable: boolean;
    subTotal: number;
    discount: number;
    total: number;
    gender: string;
    type: string;
    optionalId2: number;
    optionalId3: number;
    optionalId4: number;
    discountType?: string;
    discountAmount?: number;
    discountPercentage?: number;
    automaticTypeId:number
}